const JobType = `
  id
  description
  active
`;

export default JobType;
